import React from "react";
import "./ConfirmationModal.css";

const ConfirmationModal = ({
  message,
  onConfirm,
  onCancel,
  loading = false, // ✅ new prop
}) => {
  React.useEffect(() => {
  const handleEsc = (e) => {
    if (e.key === "Escape" && !loading) onCancel();
  };

  window.addEventListener("keydown", handleEsc);
  return () => window.removeEventListener("keydown", handleEsc);
}, [loading, onCancel]);
  return (
    <div className="modal-overlay" onClick={!loading ? onCancel: undefined}>
      <div
        className="modal-container"
        onClick={(e) => e.stopPropagation()} // ✅ prevent closing when clicking inside
      >
        <p>{message}</p>

        <div className="modal-buttons">
          <button
            className="confirm-button"
            onClick={onConfirm}
            disabled={loading} // ✅ prevent multiple clicks
          >
            {loading ? "Deleting..." : "Confirm"}
          </button>

          <button
            className="cancel-button"
            onClick={onCancel}
            disabled={loading} // ✅ prevent cancel during action
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;